/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.autocomplete.rpc.AcademyAutocompleteChirpService
 */
import { createRpcClientV2 } from 'rpc-client-utils';
import { registerQuery } from 'data-fetching-client/next';
import http from 'hub-http/clients/apiClient';
import * as References from './AcademyAutocompleteChirpService';
const chirpClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.academy.autocomplete.rpc.AcademyAutocompleteChirpService#getAutocompleteSuggestions
 */
export const GET_AUTOCOMPLETE_SUGGESTIONS_QUERY_FIELD_NAME = 'com_hubspot_academy_autocomplete_rpc_AcademyAutocompleteChirpService_getAutocompleteSuggestions';
export const GET_AUTOCOMPLETE_SUGGESTIONS_QUERY = /* #__PURE__ */registerQuery({
  fieldName: GET_AUTOCOMPLETE_SUGGESTIONS_QUERY_FIELD_NAME,
  args: ['popularTermsLimit', 'quickLinksLimit', 'language', 'queryTerm'],
  fetcher(request, ctx) {
    var _ctx$customClient;
    return ((_ctx$customClient = ctx.customClient) !== null && _ctx$customClient !== void 0 ? _ctx$customClient : chirpClient).call(References.getAutocompleteSuggestionsRpc, {
      timeout: ctx.timeout,
      request
    });
  }
});